import { render, staticRenderFns } from "./qs2-20.vue?vue&type=template&id=3da5df86&scoped=true&"
import script from "./qs2-20.vue?vue&type=script&lang=js&"
export * from "./qs2-20.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da5df86",
  null
  
)

export default component.exports